<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <label>Select file</label>
                <input type="file" @change="updateImgSrc">
            </div>
        </div>

        <div class="col-sm-10">
            <div class="row">
                <div class="col-sm-12">
                    <canvas ref="canvas" v-show="false"></canvas>
                    <img ref="source" src="../assets/tower.jpg">
                </div>
                <div class="col-sm-12">
                    <canvas ref="result"></canvas>
                </div>
            </div>

        </div>

        <div class="col-sm-2">
            <div class="form-group">
                <label>Carve width</label>
                <input v-model="carveCountWidth" type="number" placeholder="width">

            </div>
            <div class="form-group">
                <label>Carve height</label>
                <input v-model="carveCountHeight" type="number" placeholder="height">
            </div>
            <div class="form-group">
                <a class="btn btn-success" @click="carve">
                    <span v-if="loadingPercentage == 0 || loadingPercentage == 100">carve</span>
                    <span v-else>loading: {{loadingPercentage}} %</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import SeamCarvingWorker from 'worker-loader!./SeamCarver.js';
    import Matrix from "./Matrix";

    export default {
        components: {Matrix},
        data() {
            return {
                worker: null,
                imageData: null,
                width: 0,
                height: 0,
                M: [],
                backtrack: [],
                carveCountWidth: 0,
                carveCountHeight: 0,
                loadingPercentage: 0,
            }
        },
        mounted() {
            // let seamCarver = new SeamCarver();
            this.$refs.source.onload = (e) => {
                this.$refs.canvas.width = this.$refs.source.width;
                this.$refs.canvas.height = this.$refs.source.height;

                this.$refs.canvas.getContext('2d').drawImage(this.$refs.source, 0, 0, this.$refs.source.width, this.$refs.source.height);
                this.imageData = this.$refs.canvas.getContext('2d').getImageData(0, 0, this.$refs.source.width, this.$refs.source.height);

                this.initWorker()
                // this.carve()
            }
        },
        methods: {
            updateImgSrc($event) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.$refs.source.src = e.target.result
                };
                reader.readAsDataURL($event.target.files[0])
            },
            initWorker() {
                this.worker = new SeamCarvingWorker();
                this.worker.onmessage = (event) => {
                    if (event.data.action === "done") {
                        var result = event.data;

                        let ctx = this.$refs.result.getContext('2d');
                        this.width = this.$refs.result.width = result.image.width;
                        this.height = this.$refs.result.height = result.image.height;

                        this.M = result.image.M;
                        this.backtrack = result.image.backtrack;

                        var newImage = ctx.createImageData(result.image.width, result.image.height);
                        newImage.data.set(result.image.data);
                        ctx.putImageData(newImage, 0, 0);
                        this.loadingPercentage = 100;
                    }
                    if(event.data.action === "percentage") {
                        this.loadingPercentage = Math.round(event.data.percentage * 100)
                    }
                };
            },
            carve() {
                this.loadingPercentage = 1;
                this.worker.postMessage({
                    'action': 'seam-carving',
                    'image': {
                        'width': this.imageData.width,
                        'height': this.imageData.height,
                        'data': this.imageData.data
                    },
                    'resize': {
                        'width': parseInt(this.carveCountWidth),
                        'height': parseInt(this.carveCountHeight)
                    }
                });
            }
        }
    }
</script>
